// src/components/ScrollFabs.tsx
import React from "react";

export function ScrollFabs({
  showUp,
  showDown,
  onUp,
  onDown,
}: {
  showUp: boolean;
  showDown: boolean;
  onUp: () => void;
  onDown: () => void;
}) {
  return (
    <div className="scroll-fabs" aria-hidden="false">
      {showUp && (
        <button
          className="scroll-fab up"
          onClick={onUp}
          aria-label="Jump up"
          title="Jump up"
        >
          ▲
        </button>
      )}
      {showDown && (
        <button
          className="scroll-fab down"
          onClick={onDown}
          aria-label="Jump down"
          title="Jump down"
        >
          ▼
        </button>
      )}
    </div>
  );
}
